import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material'

interface UnsavedChangesCloseDialogProps {
  open: boolean
  onCancel: () => void
  onConfirmClose: () => void
  disabled?: boolean
}

export function UnsavedChangesCloseDialog({
  open,
  onCancel,
  onConfirmClose,
  disabled,
}: UnsavedChangesCloseDialogProps) {
  return (
    <Dialog open={open} disableEscapeKeyDown onClose={() => {}}>
      <DialogTitle>Unsaved changes</DialogTitle>
      <DialogContent>
        <Typography>
          You have unsaved changes. Are you sure you want to close?
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button onClick={onCancel} disabled={disabled}>
          Cancel
        </Button>
        <Button
          variant="outlined"
          color="error"
          onClick={onConfirmClose}
          disabled={disabled}
        >
          Close without saving
        </Button>
      </DialogActions>
    </Dialog>
  )
}
